export default "__VITE_ASSET__7dae564b__"